module.exports = __webpack_public_path__ + "media/img/careers/why-work/why-work-img3-afd54429a3b2fdcad7d4cf8b2f186cfc.svg";